/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.

  Modified by yang@onerockwell

==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') {
    ShopifyAPI = {};
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
    if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
            attribute = '';
        }
    }
    return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
    // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/update.js',
            data: 'note=' + attributeToString(note),
            dataType: 'json',
            beforeSend: function() {
                $body.trigger('beforeUpdateCartNote.ajaxCart', note);
            },
            success: function(cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                } else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
            },
            error: function(XMLHttpRequest, textStatus) {
                $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
        alert(data.message + '(' + data.status + '): ' + data.description);
    }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
  Yang@onerockwell Added ShopifyAPI.addMultipleItems
==============================================================================*/
ShopifyAPI.addMultipleItems = function(data, callback, errorCallback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            beforeSend: function(jqxhr, settings) {
                $body.trigger('beforeAddItem.ajaxCart');
            },
            success: function(line_item) {
                if ((typeof callback) === 'function') {
                    callback(line_item);
                } else {
                    ShopifyAPI.onItemAdded(line_item);
                }
                $body.trigger('afterAddItem.ajaxCart', [line_item]);
            },
            error: function(XMLHttpRequest, textStatus) {
                if ((typeof errorCallback) === 'function') {
                    errorCallback(XMLHttpRequest, textStatus);
                } else {
                    ShopifyAPI.onError(XMLHttpRequest, textStatus);
                }
                $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/add.js',
            data: jQuery(form).serialize(),
            dataType: 'json',
            beforeSend: function(jqxhr, settings) {
                $body.trigger('beforeAddItem.ajaxCart', form);
            },
            success: function(line_item) {
                console.log('item added to cart:', line_item);
                if ((typeof callback) === 'function') {
                    callback(line_item, form);
                } else {
                    ShopifyAPI.onItemAdded(line_item, form);
                }
                $body.trigger('afterAddItem.ajaxCart', [line_item, form]);

                // dataLayer event for GTM
                window.dataLayer?.push({
                    'event': 'AddToCart',
                    'products': [{
                        'id': line_item.id,
                        'product_id': line_item.product_id,
                        'name': line_item.product_title,
                        'price': line_item.price / 100,
                        'category': line_item.product_type,
                        'brand': 'MIC',
                        'variant': line_item.title,
                        'quantity': line_item.quantity
                    }]
                })
            },
            error: function(XMLHttpRequest, textStatus) {
                if ((typeof errorCallback) === 'function') {
                    errorCallback(XMLHttpRequest, textStatus);
                } else {
                    ShopifyAPI.onError(XMLHttpRequest, textStatus);
                }
                $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
    $(document.body).trigger('beforeGetCart.ajaxCart');
    jQuery.getJSON('/cart.js', function(cart, textStatus) {
        if ((typeof callback) === 'function') {
            callback(cart);
        } else {
            ShopifyAPI.onCartUpdate(cart);
        }
        $(document.body).trigger('afterGetCart.ajaxCart', cart);
    });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback, errorCallback) {

    const updatedProductData = JSON.parse( $(`.ajaxcart__row[data-line="${line}"] .ajaxcart__json-info`).text() );

    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/change.js',
            data: 'quantity=' + quantity + '&line=' + line,
            dataType: 'json',
            beforeSend: function() {
                $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
            },
            success: function(cart) {

                if ((typeof callback) === 'function') {
                    callback(cart, updatedProductData, quantity);
                } else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);

                if(quantity == 0){
                    //console.log('product was removed from cart');
                    //alert('Product was removed from cart');
                    // window.dataLayer.push({
                    //     'event': 'RemoveFromCart',
                    //     'products': [updatedProductData]
                    // })
                }
            },
            error: function(XMLHttpRequest, textStatus) {
                if ((typeof errorCallback) === 'function') {
                    errorCallback(XMLHttpRequest, textStatus, line);
                } else {
                    ShopifyAPI.onError(XMLHttpRequest, textStatus);
                }
                $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};



/*============================================================================
  Product Options
==============================================================================*/
ShopifyAPI.selectCallback = function(variant, selector) {
    // var moneyFormat = Shopify.money_format;
    var moneyFormat = theme.moneyFormat;
    var disabledCTAClass = 'disabled';
    const inventoryDisplayThreshold = 10;

    // Selectors
    if (selector.domIdPrefix.split('-').length > 1) {
        var selectorArray = selector.domIdPrefix.split('-');
        var $addToCart = $('[id^="AddToCart-' + selectorArray[1] +'"]');
        console.log('add to cart selector: ', '[id~="AddToCart-' + selectorArray[1] +'"]');
    } else {
        var $addToCart = $('#AddToCart');
    }

    var $productWrapper = $addToCart.parents('.product-core').length ? $addToCart.parents('.product-core') : $addToCart.parents('.quick-buy-container'),
        $productPrice = $productWrapper.find('.product-price'),
        $comparePrice = $productWrapper.find('.product-compare-price'),
        $addToCartText = $productWrapper.find('.add-to-cart-text'),
        $form = $addToCart.closest('form'),
        $outOfStockBadge = $form.find('.variant-out-of-stock-badge');

    // Variant
    if (variant) {
        // Select a valid variant if available
        if (variant.available) {
            // Available, enable the submit button, change text, show quantity elements
            $addToCart.removeClass('disabled sold-out').prop('disabled', false);
            $addToCart.removeAttr('title');
            if ($addToCart.hasClass('pre-order')) {
                $addToCartText.html("Pre Order");
            } else {
                $addToCartText.html("Agregar a mi bolsa");
            }
            if ($outOfStockBadge.length) {
                $outOfStockBadge.removeClass('show').css('display', 'none').hide();
            }
        } else {
            // Sold out, disable the submit button, change text, hide quantity elements
            $addToCart.addClass(`${disabledCTAClass} sold-out`).prop('disabled', true);
            $addToCart.attr('title', 'No hay más unidades disponibles');
            if (!$addToCart.hasClass('inquire')) {
                $addToCartText.html("No disponible");
            }
            if ($outOfStockBadge.length) {
                $outOfStockBadge.removeClass('show');
                void $outOfStockBadge[0].offsetWidth;
                $outOfStockBadge.css('display', 'block').show().addClass('show');
            }
        }
        // console.log('variant selected and update price', variant);
        if(typeof variantStock !== 'undefined'){
            // console.log('variant', variant);
            // console.log('variantStock', variantStock);
            let selectedVariantInventoryInfo = variantStock.filter( (item)=> item.variant == variant.id );
            // console.log('selectedVariantInventoryInfo', selectedVariantInventoryInfo);
            let selectedVariantInventory = variantStock.find(item => item.variant == variant.id)?.inventory ?? 0;
            let unitsWording = selectedVariantInventory == 1 ? 'unit' : 'units';
            // console.log('selectedVariantInventoryInfo', selectedVariantInventoryInfo);
            // console.log('selectedVariantInventory', selectedVariantInventory);
            // console.log('inventoryDisplayThreshold', inventoryDisplayThreshold);
            // console.log('selectedVariantInventory > 0 && selectedVariantInventory <= inventoryDisplayThreshold', selectedVariantInventory > 0 && selectedVariantInventory <= inventoryDisplayThreshold);
            if(selectedVariantInventory > 0 && selectedVariantInventory <= inventoryDisplayThreshold){
                $productWrapper.find('.variant-selection-availability').addClass('active').find('.qty').text(selectedVariantInventory);
                $productWrapper.find('.variant-selection-availability').find('units').text(unitsWording);
            }else{
                $productWrapper.find('.variant-selection-availability').removeClass('active').find('.qty').empty;
            }
        }
        // Show available units info


        // console.log(selector);
        // Regardless of stock, update the product price
        var increasedPrice = ((variant.price * GlobalObj.countryTaxRate ) / 100).toFixed(2);
        // console.log("Precio sin Impuesto", variant.price);
        // console.log("Precio comparado sin impuesto", variant.compare_at_price)
        // console.log("Precio actual con 0% Impuesto:", increasedPrice);

        var increasedCompareAtPrice = ((variant.compare_at_price * GlobalObj.countryTaxRate ) / 100).toFixed(2);
        // console.log("Precio de comparación con 15%:", increasedCompareAtPrice);
        $productPrice.html(Shopify.formatMoney(increasedPrice, moneyFormat));

        // Also update and show the product's compare price if necessary
        if (increasedCompareAtPrice > increasedPrice) {
            // console.log("Precio de comparación con 0% Impuesto:", increasedCompareAtPrice);
            // console.log("Precio actual con 0% Impuesto:", increasedPrice);
            // console.log("El precio de comparación con 0% Impuesto es mayor que el precio actual con 0% Impuesto.");
            $comparePrice.html(Shopify.formatMoney(increasedCompareAtPrice, moneyFormat)).show();
        } else {
            // console.log("Precio de comparación con 0% Impuesto:", increasedCompareAtPrice);
            // console.log("Precio actual con 0% Impuesto:", increasedPrice);
            // console.log("El precio de comparación con 0% Impuesto NO es mayor que el precio actual con 0% Impuesto.");
            $comparePrice.hide();
        }

    } else {
        $addToCart.addClass(disabledCTAClass);
        $addToCart.addClass('disabled');
        $addToCart.removeAttr('title');
        if ($outOfStockBadge.length) {
            $outOfStockBadge.removeClass('show').css('display', 'none').hide();
        }
    }

    $addToCart.removeClass('loading');
};
/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

    'use strict';

    // Public functions
    var init, loadCart;

    // Private general variables
    var settings, isUpdating, $body;

    // Private plugin variables
    var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

    // Private functions
    var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback,  buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

    /*============================================================================
      Initialise the plugin and define global options
    ==============================================================================*/
    init = function(options) {

        // Default settings
        settings = {
            formSelector: 'form[action^="/cart/add"]',
            cartContainer: '#CartContainer',
            addToCartSelector: 'input[type="submit"]',
            cartCountSelector: null,
            cartCostSelector: null,
            moneyFormat: '$',
            disableAjaxCart: false,
            enableQtySelectors: true
        };

        // Override defaults with arguments
        $.extend(settings, options);

        // Select DOM elements
        $formContainer = $(settings.formSelector);
        $cartContainer = $(settings.cartContainer);
        $addToCart = $formContainer.find(settings.addToCartSelector);
        $cartCountSelector = $(settings.cartCountSelector);
        $cartCostSelector = $(settings.cartCostSelector);

        // General Selectors
        $body = $(document.body);

        // Track cart activity status
        isUpdating = false;

        // Setup ajax quantity selectors on the any template if enableQtySelectors is true
            // console.log('enableQtySelectors??',settings.enableQtySelectors);
        if (settings.enableQtySelectors) {
            qtySelectors();
        }

        // Take over the add to cart form submit action if ajax enabled
        if (!settings.disableAjaxCart && $addToCart.length) {
            formOverride();
        }

        // Run this function in case we're using the quantity selector outside of the cart
        adjustCart();
    };

    loadCart = function() {
        $body.addClass('drawer--is-loading');
        ShopifyAPI.getCart(cartUpdateCallback);
    };

    updateCountPrice = function(cart) {
        if ($cartCountSelector) {
            $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
            $('#MiniCart').find('.item-count').text(cart.item_count).addClass('updated');

            if (cart.item_count === 0) {
                $cartCountSelector.addClass('hidden-count');
            }
        }
        if ($cartCostSelector) {
            $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
        }
    };

    formOverride = function() {
        $formContainer.on('submit', function(evt) {
            evt.preventDefault();
            var proceed = true;
            var $currForm = $(evt.target);
            var $selects = $currForm.find('select');
            $.each($selects, function(i, v) {
                if ($(v).val() == '') {
                    proceed = false;
                    return false;
                }
            });

            if (!proceed) {
                alert('Please select all options');
                return false;
            }

            // Validación formulario destinatario regalo: si el checkbox está marcado, email obligatorio y fecha dentro de 90 días
            var $recipientSection = $currForm.find('.gift-card-recipient-section');
            if ($recipientSection.length) {
                var $recipientCheckbox = $recipientSection.find('.recipient-checkbox-input');
                if ($recipientCheckbox.length && $recipientCheckbox.is(':checked')) {
                    var recipientEmail = $currForm.find('input[name="properties[Recipient email]"]').val();
                    if (!recipientEmail || !String(recipientEmail).trim()) {
                        $(document).find('.qty-error').remove();
                        $recipientSection.find('.recipient-fields').first().before('<div class="errors qty-error" style="color:#c00;margin-bottom:12px;">Por favor ingresa el correo electrónico del destinatario del regalo.</div>');
                        return false;
                    }
                    var sendOnVal = $currForm.find('input[name="properties[Send on]"]').val();
                    if (sendOnVal) {
                        var parts = sendOnVal.split('-');
                        var sendOn = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
                        var today = new Date();
                        today.setHours(0, 0, 0, 0);
                        var maxDate = new Date(today);
                        maxDate.setDate(maxDate.getDate() + 90);
                        sendOn.setHours(0, 0, 0, 0);
                        if (sendOn < today || sendOn > maxDate) {
                            $(document).find('.qty-error').remove();
                            $recipientSection.find('.recipient-fields').first().before('<div class="errors qty-error" style="color:#c00;margin-bottom:12px;">La fecha de envío debe estar dentro de los próximos 90 días.</div>');
                            return false;
                        }
                    }
                }
            }

            // Get the add to cart button for this specific form
            var $currentAddToCartBtn = $currForm.find('button[type="submit"][name="add"]');
            $currentAddToCartBtn.removeClass('is-added').addClass('is-adding');

            // Remove any previous quantity errors
            $(document).find('.qty-error').remove();

            // Para gift card: que solo se envíe value "true" (el hidden), no el checkbox "on"
            var $giftCheckbox = $currForm.find('.gift-card-recipient-section .recipient-checkbox-input');
            if ($giftCheckbox.length && $giftCheckbox.is(':checked')) {
                $giftCheckbox.prop('disabled', true);
            }

            var errorCallback = function(res, text) {
                itemErrorCallback(res, text, $currForm);
            };
            ShopifyAPI.addItemFromForm(evt.target, function(lineItem) {
                if ($giftCheckbox.length) $giftCheckbox.prop('disabled', false);
                itemAddedCallback(lineItem);
            }, function(res, text) {
                if ($giftCheckbox.length) $giftCheckbox.prop('disabled', false);
                errorCallback(res, text);
            });
        });
    };

    itemAddedCallback = function(line_item) {
        console.log('itemAddedCallback:', line_item);
        $addToCart.removeClass('is-adding').addClass('is-added');

        ShopifyAPI.getCart(function(cart) {
            cartUpdateCallback( cart );
            const itemAddedEvent = new Event('afterAddToCart.ajaxCart', cart);
            document.body.dispatchEvent(itemAddedEvent);
        });
    };

    itemErrorCallback = function(res, text, $form) {
        var $targetForm = $form && $form.length ? $form : $addToCart.closest('form');
        var $currentAddToCartBtn = $targetForm.find('button[type="submit"][name="add"]');
        $currentAddToCartBtn.removeClass('is-adding is-added');

        if (!!text && res.status == 422) {
            var data = res.responseJSON || {};
            var rawMessage = data.description || data.message || '';
            if ((!rawMessage || typeof rawMessage !== 'string') && data.errors) {
                var errParts = [];
                if (typeof data.errors === 'string') {
                    errParts.push(data.errors);
                } else if (Array.isArray(data.errors)) {
                    errParts = data.errors;
                } else {
                    for (var k in data.errors) {
                        var v = data.errors[k];
                        errParts.push(Array.isArray(v) ? v.join(' ') : v);
                    }
                }
                rawMessage = errParts.join(' ');
            }
            var displayMessage = typeof rawMessage === 'string' ? rawMessage : (Array.isArray(rawMessage) ? rawMessage.join(' ') : (rawMessage && rawMessage.message ? rawMessage.message : 'Por favor verifica los datos del destinatario e intenta de nuevo.'));
            var message = (displayMessage || '').toString().toLowerCase();

            // Como en Agua Bendita: siempre mostrar el mensaje de error cerca del form (asegurar que sea string para evitar [object Object])
            $(document).find('.qty-error').remove();
            var messageText = (typeof displayMessage === 'string' ? displayMessage : 'Por favor verifica los datos e intenta de nuevo.');
            if (messageText) {
                var $errorContainer = $targetForm.find('.gift-card-recipient-section .recipient-fields').length
                    ? $targetForm.find('.gift-card-recipient-section .recipient-fields').first()
                    : $targetForm.find('.prod-core-form__footer').first();
                if ($errorContainer.length) {
                    $errorContainer.before('<div class="errors qty-error" style="color:#c00;margin-bottom:12px;">' + messageText + '</div>');
                } else {
                    $targetForm.after('<div class="errors qty-error" style="color:#c00;margin:12px 0;">' + messageText + '</div>');
                }
            }

            // Solo deshabilitar botón y mostrar "No disponible" si el mensaje indica claramente falta de stock (como antes)
            var isSoldOutError = message.indexOf('unavailable') !== -1 || message.indexOf('sold out') !== -1 || message.indexOf('not available') !== -1 || message.indexOf('no hay') !== -1 || message.indexOf('agotad') !== -1;
            if (isSoldOutError && $currentAddToCartBtn.length) {
                var $currentBadge = $targetForm.find('.variant-out-of-stock-badge');
                if ($currentBadge.length) { $currentBadge.css('display', 'block').show(); }
                $currentAddToCartBtn.addClass('disabled sold-out').prop('disabled', true);
                $currentAddToCartBtn.attr('title', 'No hay más unidades disponibles');
                var $addToCartText = $currentAddToCartBtn.find('.add-to-cart-text');
                if ($addToCartText.length) {
                    $addToCartText.html("No disponible");
                }
            }
        }
    };

    cartUpdateCallback = function(cart) {
        console.log('cartUpdateCallback', cart);
        // Update quantity and price
        updateCountPrice(cart);
        buildCart(cart);
    };

    buildCart = function(cart) {
        // Start with a fresh cart div
        $cartContainer.empty();

        // Show empty cart
        if (cart.item_count === 0) {
            $cartContainer
                .append('<p class="ajaxcart__empty">' + "Tu bolsa de compras está vacía" + '</p>');
            cartCallback(cart);
            return;
        }

        // Handlebars.js cart layout
        var items = [],
            item = {},
            data = {},
            source = $("#CartTemplate").html(),
            template = Handlebars.compile(source);

        console.log(cart.items);

        // Add each item to our handlebars.js data
        $.each(cart.items, function(index, cartItem) {
            /* Hack to get product image thumbnail
             *   - If image is not null
             *     - Remove file extension, add _small, and re-add extension
             *     - Create server relative link
             *   - A hard-coded url of no-image
             */
            if (cartItem.image != null) {
                var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '');
            } else {
                var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
            }

            var secondaryIds = typeof themeSecondaryBrandProductIds !== 'undefined' && Array.isArray(themeSecondaryBrandProductIds) ? themeSecondaryBrandProductIds : [];
            var isSecondaryBrand = secondaryIds.indexOf(cartItem.product_id) !== -1;

            // Filtrar y traducir propiedades (como en Agua Bendita): ocultar claves internas __shopify_* y traducir gift card
            var propertyTranslations = {
                'Message': 'Mensaje',
                'Recipient email': 'Correo del destinatario',
                'Recipient name': 'Nombre del destinatario',
                'Send on': 'Enviar el'
            };
            function getDisplayProperties(properties) {
                if (!properties || typeof properties !== 'object') return {};
                var out = {};
                for (var key in properties) {
                    if (key.indexOf('__') === 0) continue; // ocultar __shopify_send_gift_card_to_recipient, __shopify_offset, etc.
                    var label = propertyTranslations[key] || key;
                    var val = properties[key];
                    if (val !== '' && val != null) out[label] = val;
                }
                return out;
            }
            var displayProperties = getDisplayProperties(cartItem.properties);

            // Create item's data object and add to 'items' array
            item = {
                key: cartItem.key,
                id: cartItem.id,
                product_id: cartItem.product_id,
                line: index + 1, // Shopify uses a 1+ index in the API
                url: cartItem.url,
                img: prodImg,
                name: cartItem.product_title.replace('MIC ',''),
                variation: cartItem.variant_title,
                variant_name: cartItem.title,
                properties: displayProperties,
                itemAdd: cartItem.quantity + 1,
                itemMinus: cartItem.quantity - 1,
                itemQty: cartItem.quantity,
                price_noformat: cartItem.price / 100,
                price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
                vendor: cartItem.vendor,
                product_type: cartItem.product_type,
                linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
                originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
                discounts: cartItem.discounts,
                discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
                isGiftCard: cartItem.gift_card,
                isSecondaryBrand: isSecondaryBrand
            };

            items.push(item);
        });

        let currentDate = 1775101322;
        let freeShippingBar = false;
        let freeShippingMinimum = 50;
        let freeShippingLabelEnable = false;
        let freeShippingLabel = true;
        let freeShippingLabelMessage = "¡ENVÍO GRATIS EN TODA LA TIENDA!";
        let freeShippingCurrentDay = new Date(currentDate * 1000);
        let freeShippingActiveFrom = "2026-01-15 00:00";
        let freeShippingPastDay = new Date(freeShippingActiveFrom.replace(' ', 'T'));
        let freeShippingActiveTo = "2026-01-20 00:00";
        let freeShippingFutureDay = new Date(freeShippingActiveTo.replace(' ', 'T'));
        let freeShippingMessage = '';
        let freeShippingRemainingValue = '';
        let freeShippingRemainingPercentage = '';

        if (freeShippingMinimum != '') {
            freeShippingBar = true;
            freeShippingRemainingValue = (freeShippingMinimum - (cart.total_price / 100)).toFixed(2);
            freeShippingRemainingPercentage = ( ( cart.total_price / 100) / freeShippingMinimum ) * 100;

            freeShippingRemainingPercentage = freeShippingRemainingPercentage > 100 ? 100 : freeShippingRemainingPercentage;

            if(freeShippingRemainingValue < 1){
                freeShippingMessage = '¡Tu envío es totalmente gratis!'
            }else{
                freeShippingMessage = 'Faltan [value] para que tu envío sea gratis!'
                freeShippingMessage = freeShippingMessage.replace('[value]', '$' + freeShippingRemainingValue )
            }
        }

        if(freeShippingLabel) {
            freeShippingLabelEnable = true;
            if(freeShippingCurrentDay < freeShippingPastDay) {
                freeShippingLabelEnable = false;
            } else if(freeShippingCurrentDay > freeShippingFutureDay) {
                freeShippingLabelEnable = false;
            }
        } else {
            freeShippingLabelEnable = false;
        }

        // Gather all cart data and add to DOM
        data = {
            items: items,
            note: cart.note,
            totalItems: items.length,
            totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
            totalCartDiscount: cart.total_discount === 0 ? 0 : "\u003cp\u003eAhorras\u003c\/p\u003e".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
            totalCartDiscountApplied: cart.total_discount === 0 ? false : true,
            freeShippingBar: freeShippingBar,
            freeShippingLabelEnable: freeShippingLabelEnable,
            freeShippingLabelMessage: freeShippingLabelMessage,
            freeShippingMessage: freeShippingMessage,
            freeShippingMinimum: freeShippingMinimum,
            freeShippingRemainingValue: freeShippingRemainingValue,
            freeShippingRemainingPercentage: freeShippingRemainingPercentage
        }

        console.log('cart data:', data)

        $cartContainer.append(template(data));

        cartCallback(cart);
    };

    cartCallback = function(cart) {
        console.log('cartCallback');
        $body.removeClass('drawer--is-loading');
        $body.trigger('afterCartLoad.ajaxCart', cart);

        if (window.Shopify && Shopify.StorefrontExpressButtons) {
            Shopify.StorefrontExpressButtons.initialize();
        }
    };

    adjustCart = function() {
        // Delegate all events because elements reload with the cart

        // Add or remove from the quantity
        $(document).on('click', '.ajaxcart__qty-adjust', function(evt) {
            evt.preventDefault();
            console.log('ajaxcart__qty-adjust click', evt);
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                line = $el.data('line'),
                $qtySelector = $el.siblings('.ajaxcart__qty-num'),
                qty = parseInt($qtySelector.val().replace(/\D/g, ''));

            var qty = validateQty(qty);

            // Add or subtract from the current quantity
            if ($el.hasClass('ajaxcart__qty--plus')) {
                qty += 1;
            } else {
                qty -= 1;
                if (qty <= 0) qty = 0;
            }

            // If it has a data-line, update the cart.
            // Otherwise, just update the input's number
            if (line) {
                console.log('adjust quantity');
                updateQuantity(line, qty);
            } else {
                $qtySelector.val(qty);
            }
        });

        $(document).on('click', '.ajaxcart__qty-remove', function(e) {
            e.preventDefault();
            console.log('.ajaxcart__qty-remove click to remove');
            var $el = $(this),
                line = $el.data('line');

            if (isUpdating) {
                return;
            }
            updateQuantity(line, 0);
        });

        // Update quantity based on input on change
        $(document).on('change', '.ajaxcart__qty-num', function() {
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                line = $el.data('line'),
                qty = parseInt($el.val().replace(/\D/g, ''));

            var qty = validateQty(qty);

            // If it has a data-line, update the cart
            if (line) {
                updateQuantity(line, qty);
            }
        });

        // Prevent cart from being submitted while quantities are changing
        $body.on('submit', 'form.ajaxcart', function(evt) {
            if (isUpdating) {
                evt.preventDefault();
            }
        });

        // Highlight the text when focused
        $(document).on('focus', '.ajaxcart__qty-adjust', function(evt) {
            var $el = $(this);
            setTimeout(function() {
                $el.select();
            }, 50);
        });

        function showOutOfStockBadge(line) {
            var $row = $('.ajaxcart__row[data-line="' + line + '"]');
            var $badge = $row.find('.ajaxcart__out-of-stock-badge');
            if (!$badge.length && $cartContainer && $cartContainer.length) {
                $badge = $cartContainer.find('.ajaxcart__out-of-stock-badge[data-line="' + line + '"]');
            }
            if ($badge.length) {
                // Aseguramos que la FILA del producto quede visible dentro del contenedor scrollable
                if ($cartContainer && $cartContainer.length && $row.length) {
                    var $inner = $cartContainer.find('.ajaxcart__inner');
                    if ($inner.length) {
                        var innerEl = $inner[0];
                        var rowEl = $row[0];
                        var rowOffset = rowEl.offsetTop; // relativo al contenedor
                        var marginTop = 12; // pequeño margen desde arriba
                        innerEl.scrollTop = Math.max(rowOffset - marginTop, 0);
                    }
                }
                $badge.removeClass('show');
                void $badge[0].offsetWidth;
                $badge.css('display', 'block').show().addClass('show');
                setTimeout(function() {
                    $badge.removeClass('show').fadeOut(300, function() {
                        $badge.css('display', 'none');
                    });
                }, 2500);
            }
        }

        function updateQuantity(line, qty) {
            console.log('updateQuantity');
            isUpdating = true;

            // Add activity classes when changing cart quantities
            var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

            if (qty === 0) {
                $row.parent().addClass('is-removed');
            }

            var errorCallback = function(res, text, lineParam) {
                isUpdating = false;
                $row.removeClass('is-loading');
                if (res.status == 422) {
                    showOutOfStockBadge(line);
                    ShopifyAPI.getCart(function(cart) {
                        var currentItem = cart.items[line - 1];
                        if (currentItem) {
                            var $qtyInput = $row.find('.ajaxcart__qty-num');
                            $qtyInput.val(currentItem.quantity);
                        }
                    });
                }
            };

            var successCallback = function(cart, updatedProductData, quantity) {
                var item = cart.items[line - 1];
                var requestedQty = parseInt(quantity, 10) || 0;
                var actualQty = item ? (parseInt(item.quantity, 10) || 0) : 0;
                var quantityLimited = requestedQty > 0 && actualQty < requestedQty;
                if (quantityLimited) {
                    updateCountPrice(cart);
                    buildCart(cart);
                    isUpdating = false;
                    setTimeout(function() {
                        showOutOfStockBadge(line);
                    }, 150);
                    if ($body.trigger) {
                        $body.trigger('adjustCartCallback.ajaxCart', [cart]);
                    }
                } else {
                    adjustCartCallback(cart, updatedProductData, quantity);
                }
            };

            setTimeout(function() {
                ShopifyAPI.changeItem(line, qty, successCallback, errorCallback);
            }, 250);
        }

        // Save note anytime it's changed
        $body.on('change', 'textarea[name="note"]', function() {
            var newNote = $(this).val();

            // Update the cart note in case they don't click update/checkout
            ShopifyAPI.updateCartNote(newNote, function(cart) {});
        });
    };

    adjustCartCallback = function(cart, updatedProductData, quantity) {
        console.log('adjustCartCallback');
        // Update quantity and price
        updateCountPrice( cart );

        const adjustCartEvent = new Event('adjustCartCallback.ajaxCart', cart);
        document.body.dispatchEvent(adjustCartEvent);

        // Reprint cart on short timeout so you don't see the content being removed
        setTimeout(function() {
            isUpdating = false;
            ShopifyAPI.getCart(buildCart);
        }, 150)
    };

    createQtySelectors = function() {
        // If there is a normal quantity number field in the ajax cart, replace it with our version
        if ($('input[type="number"]', $cartContainer).length) {
            $('input[type="number"]', $cartContainer).each(function() {
                var $el = $(this),
                    currentQty = $el.val();

                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;

                var source = $("#AjaxQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        key: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus
                    };

                // Append new quantity selector then remove original
                $el.after(template(data)).remove();
            });
        }
    };

    qtySelectors = function() {
        // Change number inputs to JS ones, similar to ajax cart but without API integration.
        // Make sure to add the existing name and id to the new input element
        var numInputs = $('input.enable-qty-selector');

        if (numInputs.length) {
            numInputs.each(function() {
                var $el = $(this),
                    currentQty = $el.val(),
                    inputName = $el.attr('name'),
                    inputId = $el.attr('id');

                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;

                var source = $("#JsQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        key: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus,
                        inputName: inputName,
                        inputId: inputId
                    };

                // Append new quantity selector then remove original
                $el.after(template(data)).remove();
            });

            // Setup listeners to add/subtract from the input
            $('.js-qty__adjust').on('click', function() {
                var $el = $(this),
                    id = $el.data('id'),
                    $qtySelector = $el.siblings('.js-qty__num'),
                    qty = parseInt($qtySelector.val().replace(/\D/g, ''));

                var qty = validateQty(qty);

                // Add or subtract from the current quantity
                if ($el.hasClass('js-qty__adjust--plus')) {
                    qty += 1;
                } else {
                    qty -= 1;
                    if (qty <= 1) qty = 1;
                }

                // Update the input's number
                $qtySelector.val(qty);
            });
        }
    };

    validateQty = function(qty) {
        if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
            // We have a valid number!
        } else {
            // Not a number. Default to 1.
            qty = 1;
        }
        return qty;
    };

    module = {
        init: init,
        load: loadCart
    };

    return module;

}(ajaxCart || {}, jQuery));